import React from 'react'
import Collection from '../components/Collection'

const Account = () => {
  return (
    <div className=' w-full h-full p-4'>
        <h2 className=' text-3xl text-center'>My Profile</h2>
        <Collection />
    </div>
  )
}

export default Account